import { useGetIdentity, useGetOne } from 'react-admin';
import { useMemo } from 'react';
import extractIdFromURI from '@/utils/id';
import { composeUri } from '@/utils/compose';
import { USERS } from '@/utils/CONST';
import { User } from '@/utils/types';

interface Output {
    currentUser: User;
    isLoading: boolean;
    currentUserId: string | undefined;
    refetch: any;
}

const useGetCurrentUserV2 = (enabled = true): Output => {
    const { identity, isLoading: isLoadingIdentity } = useGetIdentity();

    const userId = useMemo(() => identity?.user_id ?? '', [identity]);

    const {
        data: currentUser,
        isLoading: isLoadingUser,
        refetch,
    } = useGetOne(
        USERS,
        {
            id: composeUri(USERS, userId),
        },
        { enabled: userId !== '' && enabled && !isLoadingIdentity },
    );

    const currentUserFinal: User = useMemo(
        () => (currentUser ? { ...currentUser, id: extractIdFromURI(currentUser.id) } : undefined),
        [currentUser],
    );

    return {
        currentUser: currentUserFinal,
        isLoading: isLoadingIdentity || isLoadingUser,
        currentUserId: currentUserFinal ? (currentUserFinal.id as string) : undefined,
        refetch,
    };
};

export default useGetCurrentUserV2;
